import { InMemoryWebStorage, WebStorageStateStore, UserManagerSettings } from 'oidc-client-ts';
import { checkFestoDomain } from '../../utils';

interface UserManagerSettingsExtented extends UserManagerSettings {
  skipAuth: boolean;
  state: boolean;
}

export const storage = window.sessionStorage;

export const settings: UserManagerSettingsExtented = {
  skipAuth: false,
  authority: `${process.env.REACT_APP_OAUTH_AUTHORITY}`,
  client_id: `${process.env.REACT_APP_OAUTH_CLIENT_ID}`,
  redirect_uri: checkFestoDomain(
    `${process.env.REACT_APP_OAUTH_CALLBACK_URL}`,
    `${process.env.REACT_APP_OAUTH_CALLBACK_URL_CHINA}`,
  ),
  silent_redirect_uri: checkFestoDomain(
    `${process.env.REACT_APP_OAUTH_SILENT_RENEW_URL}`,
    `${process.env.REACT_APP_OAUTH_SILENT_RENEW_URL_CHINA}`,
  ),
  popup_redirect_uri: checkFestoDomain(
    `${process.env.REACT_APP_OAUTH_LOGOUT_URL}`,
    `${process.env.REACT_APP_OAUTH_LOGOUT_URL_CHINA}`,
  ),
  response_type: `${process.env.REACT_APP_OAUTH_RESPONSE_TYPE}`,
  resource: `${process.env.REACT_APP_OAUTH_RESOURCE}`,
  scope: `${process.env.REACT_APP_OAUTH_SCOPE}`,
  automaticSilentRenew: true,
  state: true,
  loadUserInfo: false,
  requestTimeoutInSeconds: 60,
  silentRequestTimeoutInSeconds: 60,
  metadata: {
    issuer: `${process.env.REACT_APP_OAUTH_ISSUER}`,
    jwks_uri: `${process.env.REACT_APP_OAUTH_JWKS_URI}`,
    end_session_endpoint: `${process.env.REACT_APP_OAUTH_END_SESSION_ENDPOINT}`,
    authorization_endpoint: `${process.env.REACT_APP_OAUTH_AUTHORIZATION_ENDPOINT}`,
    userinfo_endpoint: `${process.env.REACT_APP_OAUTH_USERINFO_ENDPOINT}`,
    token_endpoint: `${process.env.REACT_APP_OAUTH_TOKEN_ENDPOINT}`,
  },
  userStore: new WebStorageStateStore({ store: new InMemoryWebStorage() }),
};
